import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceMemberItemFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'fullName'>
  & { nonPublic?: Types.Maybe<(
    { __typename: 'Member_NonPublic' }
    & Pick<Types.Member_NonPublic, 'fullName'>
  )> }
);

export const WorkspaceMemberItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceMemberItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nonPublic' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceMemberItemFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceMemberItemFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceMemberItemFragmentResult
  extends Omit<Apollo.UseFragmentResult<WorkspaceMemberItemFragment>, 'data'> {
  data?: WorkspaceMemberItemFragment;
}

export const useWorkspaceMemberItemFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceMemberItemFragmentOptions): UseWorkspaceMemberItemFragmentResult => {
  const result = Apollo.useFragment<WorkspaceMemberItemFragment>({
    ...options,
    fragment: WorkspaceMemberItemFragmentDoc,
    fragmentName: 'WorkspaceMemberItem',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as WorkspaceMemberItemFragment };
};
